// extracted by mini-css-extract-plugin
export default {"noLeftMargin":"KS0Q9yLhKw6Em__pnGGA"};